import { render, staticRenderFns } from "./ChangePlate.vue?vue&type=template&id=bfc735c0&"
import script from "./ChangePlate.vue?vue&type=script&lang=js&"
export * from "./ChangePlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports